import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { ColumnMode } from '@swimlane/ngx-datatable';

import { ProformaCreateDataBase, LineaProformaCreateDataBase, BaseUser, QuproServiceError, ProformasFilter,
  ProformasOrder, ProformasOrderType } from '@arpada/arp-lib-common-qupro';

import { PortalProveedorService, UiService } from '../../../services/api.services';
import { FuturaLineaProformaFront } from '../../../models/api.models';

import { SendClickEventEmitter } from '../send.click.event.emitter';
import { ElipsisModalComponent } from '../../shared/elipsis-modal/elipsis-modal.component';

@Component({
  selector: 'app-issues-resumen-proforma-escritorio',
  templateUrl: './issues-resumen-proforma-escritorio.component.html',
  styleUrls: ['./issues-resumen-proforma-escritorio.component.scss'],
})
export class IssuesResumenProformaEscritorioComponent implements OnInit {

  @Input() proformasToCreate: FuturaLineaProformaFront[];

  @Output() finishClicked = new EventEmitter();
  @Output() backClicked = new EventEmitter();

  ColumnMode = ColumnMode;
  newAmount = 0;
  proformaCreateDataBase: ProformaCreateDataBase = new ProformaCreateDataBase();
  linesIds: LineaProformaCreateDataBase[] = [];
  supplier: BaseUser;
  disabledButton = false;

  constructor(private portalProveedorService: PortalProveedorService,
              private modalCtrl: ModalController,
              private uiService: UiService,
              private router: Router) { }

  ngOnInit() {
    this.portalProveedorService.getSupplierData().subscribe((resp: BaseUser) => {
      this.supplier = resp;
      const supplierPartnerId: number = this.supplier.partner_id;
      this.proformaCreateDataBase.supplier_partner_id = supplierPartnerId;
      this.proformasToCreate.forEach(proformaToCreate => {
        // como son todas de la misma obra cojo de cualquiera el csite_id
        this.proformaCreateDataBase.csite_id = proformaToCreate.issueFrontAsociada.csite_id;
        const lineIds: LineaProformaCreateDataBase = new LineaProformaCreateDataBase();
        lineIds.issue_id = proformaToCreate.issueFrontAsociada.id;
        if (!isNaN(proformaToCreate.material)) {
          this.newAmount = this.newAmount + Number(proformaToCreate.material);
          lineIds.material_cost = Number(proformaToCreate.material);
        }
        if (!isNaN(proformaToCreate.manoObra)) {
          this.newAmount = this.newAmount + Number(proformaToCreate.manoObra);
          lineIds.labor_cost = Number(proformaToCreate.manoObra);
        }
        this.linesIds.push(lineIds);
      });
      this.proformaCreateDataBase.line_ids = this.linesIds;
    });
  }

  async abrirDescripcion(value: string) {
    if (value && value.length > 0) {
      const modal = await this.modalCtrl.create({
        component: ElipsisModalComponent,
        componentProps: {
          isModal: true,
          descripcion: value
        }
      });
      await modal.present();
    }
  }

  finalizar() {
    this.disabledButton = true;
    this.portalProveedorService.createProforma(this.proformaCreateDataBase).subscribe((resp: number[]) => {
      let message = ''
      if (resp.length > 1) {
        message = 'Partes de trabajo (Proformas) con ids: ' + resp + ' creadas con éxito.';  
      } else {

        message = 'Parte de trabajo (Proforma) con id: ' + resp + ' creada con éxito.';
      }
      this.showOkToast(message);
      this.router.navigate(['main', 'proformas']).then(() => {
        // así me aseguro que ha cargado el componente al que quiero ir
        this.portalProveedorService.createProformaEvent.emit();
        this.disabledButton = false;
      });
    }, (error: QuproServiceError) => {
      this.showErrorToast(error.message);
      this.disabledButton = false;
    });
  }

  atras() {
    // console.log('proformasToCreate recibidas por eventEmitter y devueltas para atrás: ', this.proformasToCreate);
    this.newAmount = 0;
    const toSend: SendClickEventEmitter = new SendClickEventEmitter();
    toSend.clicked = true;
    toSend.tabla = 'resumen-proformable-escritorio';
    toSend.proformasToCreate = this.proformasToCreate;
    this.backClicked.emit(toSend);
  }

  private showOkToast(message: string) {
    this.uiService.showSimpleBottomToast(message, 2000);
  }

  private showErrorToast(message: string) {
    this.uiService.showMiddleToastWithButton(message, 2000000);
  }

  getHeaderClass({ row, column, value }): any {
    if (column.prop === 'manoObra' || column.prop === 'material') {
      return {
        'cell-right-position': true
      };
    }
  }

  getCellClass({ row, column, value }): any {
    if (column.prop === 'manoObra' || column.prop === 'material') {
      return {
        'cell-right-position': true
      };
    }
  }

}
